import { mdiPencilOutline } from "@mdi/js";
import Icon from "@mdi/react";
import axios from "axios";
import "ol-ext/dist/ol-ext.css";
import React, { useCallback, useEffect, useState } from "react";
import ReactDOMServer from "react-dom/server";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { _serverUrl2 } from "../../config";
import { mapPopup } from "../../Utils/MapTools";
import ActiveUsers from "../Layout/ActiveUsers";
import AdresComponent from "../Layout/AdresComponent";
import LayersComponent2 from "../Layout/LayersComponent2";
import { addMainLayersToMap } from "./Layers/MainLayers";
import { addSingleFeatureTouserLayerByXY, locationLayer, userLayer } from "./Layers/UsersLayers";
import "./Map.css";
import { MyMap } from "./View/MyMap";

export default function MapComponent() {
  const getUserInfo = useSelector((state) => state.getUserInfo);
  const [isSvgOpen, setIsSvgOpen] = useState(false);
  const [userList, setUserList] = useState([]);
  const [isInfo, setIsInfo] = useState(false);
  const history = useHistory();

  const onClickMap = useCallback(
    async (e) => {
      await axios
        .get(_serverUrl2 + "/main/getLocationInfo/" + e.coordinate[0] + "/" + e.coordinate[1])
        .then((res) => {
          if (res.data.status) {
            if (res.data.rows.length == 0) {
              mapPopup.hide();
              return;
            }
            let filteredResult = res.data.rows; // Kullanıcın rolüne göre gelen cevabı filtreleyip gösterir.
            if (!getUserInfo.Rol.includes("8")) {
              filteredResult = filteredResult.filter((d) => d.type != "Direk/Duvar");
            }
            if (!getUserInfo.Rol.includes("7")) {
              filteredResult = filteredResult.filter((d) => d.type != "Numarataj");
            }
            if (!getUserInfo.Rol.includes("4")) {
              filteredResult = filteredResult.filter((d) => d.type != "Görev");
            }
            if (!getUserInfo.Rol.includes("16")) {
              filteredResult = filteredResult.filter((d) => d.type != "newGorev");
            }

            let str = (
              <div className="row">
                <div className="col-sm-12">
                  <table className="table table-sm table-bordered" style={{ fontSize: "11px" }}>
                    <tbody>
                      <tr>
                        <th colSpan={2}>Konum Bilgileri</th>
                        <td>
                          <button
                            id="closePopup"
                            style={{
                              fontSize: "11px",
                              padding: "0px",
                            }}
                            className="redBtn"
                          >
                            X
                          </button>
                        </td>
                      </tr>
                      {filteredResult
                        .filter((d) => d.type != "newGorev")
                        .map((d, i) => {
                          return (
                            <tr key={i}>
                              <td>{d.type}</td>
                              <td>{d.ad}</td>
                              <td>
                                <button
                                  id={"SHOWPOPUP" + i}
                                  style={{
                                    fontSize: "11px",
                                    padding: "1px",
                                  }}
                                  className="blueBtn"
                                >
                                  <Icon path={mdiPencilOutline} size={1} />
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </div>
            );

            if (filteredResult.filter((d) => d.type == "newGorev").length == 1 && filteredResult.filter((d) => d.type == "Görev").length == 0) {
              str = (
                <div className="row">
                  <div className="col-sm-12" style={{ width: "400px" }}>
                    <table className="table table-sm table-bordered" style={{ fontSize: "11px" }}>
                      <tbody>
                        <tr>
                          <td
                            colSpan={2}
                            style={{
                              alignContent: "center",
                            }}
                          >
                            <span
                              style={{
                                fontSize: "14px",
                                color: "RED",
                              }}
                            >
                              {" "}
                              BİLGİLENDİRME
                            </span>
                          </td>
                          <td>
                            <button
                              id="closePopup"
                              style={{
                                fontSize: "11px",
                                padding: "0px",
                              }}
                              className="redBtn"
                            >
                              X
                            </button>
                          </td>
                        </tr>
                        {filteredResult.map((d, i) => {
                          return (
                            <tr key={i}>
                              <td
                                colSpan={3}
                                style={{
                                  fontSize: "13px",
                                }}
                              >
                                {d.maks_kimlik_no + " maks kimlik nolu binayı deprem öncesi bina olarak atamak istediğinize emin misiniz?"}
                                <br></br>
                                <button
                                  id={"SHOWPOPUP" + i}
                                  style={{
                                    fontSize: "11px",
                                    padding: "1px",
                                    width: "60px",
                                    marginLeft: "75px",
                                  }}
                                  className="blueBtn"
                                >
                                  EVET
                                </button>
                                <button
                                  id="hayirclosePopup"
                                  style={{
                                    fontSize: "11px",
                                    padding: "1px",
                                    width: "50px",
                                    marginLeft: "50px",
                                  }}
                                  className="redBtn"
                                >
                                  HAYIR
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              );
            } else if (filteredResult.filter((d) => d.type == "newGorev").length > 1 && filteredResult.filter((d) => d.type == "Görev").length == 0) {
              str = (
                <div className="row">
                  <div className="col-sm-12" style={{ width: "400px" }}>
                    <table className="table table-sm table-bordered" style={{ fontSize: "11px" }}>
                      <tbody>
                        <tr>
                          <td
                            colSpan={2}
                            style={{
                              alignContent: "center",
                            }}
                          >
                            <span
                              style={{
                                fontSize: "14px",
                              }}
                            >
                              {" "}
                              Seçilen alan birden fazla binayı içerdiğinden işlem yapamazsınız. Lütfen seçmek istediğiniz binayı yakınlaştırıp seçiniz
                            </span>
                          </td>
                          <td>
                            <button
                              id="closePopup"
                              style={{
                                fontSize: "11px",
                                padding: "0px",
                              }}
                              className="redBtn"
                            >
                              X
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              );
            }

            mapPopup.show(e.coordinate, ReactDOMServer.renderToStaticMarkup(str));
            document.getElementById("closePopup").onclick = () => mapPopup.hide();

            for (let i = 0; i < filteredResult.length; i++) {
              const element = filteredResult[i];

              if (element.type == "Numarataj") {
                document.getElementById("SHOWPOPUP" + i).onclick = () => history.push("/dashboard/hsign/update/" + element.id);
              } else if (element.type == "Direk/Duvar") {
                document.getElementById("SHOWPOPUP" + i).onclick = () => history.push("/dashboard/sign/update/" + element.id);
              } else if (element.type == "Görev") {
                document.getElementById("SHOWPOPUP" + i).onclick = () => history.push("/dashboard/projectValues/" + element.id);
              } else if (
                element.type == "newGorev" &&
                filteredResult.filter((d) => d.type == "newGorev").length == 1 &&
                filteredResult.filter((d) => d.type == "Görev").length == 0
              ) {
                document.getElementById("hayirclosePopup").onclick = () => mapPopup.hide();
                document.getElementById("SHOWPOPUP" + i).onclick = () => {
                  axios
                    .post(_serverUrl2 + "/projects/addNewGorev/" + getUserInfo.Id, filteredResult[0])
                    .then((res) => {
                      if (res.data) {
                        mapPopup.hide();
                        alert(filteredResult[0].maks_kimlik_no + " kimlik nolu bina eklendi.");
                      } else {
                        alert("Bir sorun oluştu.Bina eklenemedi.");
                        console.log(res.data.error);
                      }
                    })
                    .catch((err) => {
                      console.log(err);
                    });
                };
              }
            }
          } else {
            mapPopup.hide();
          }
        })
        .catch(() => {
          mapPopup.hide();
        });
    },
    [getUserInfo.Id, getUserInfo.Rol, history]
  );

  const setDisplaySVG = (d) => {
    setIsSvgOpen({
      isOpen: d.isOpen,
      svg: d.svg,
    });
  };

  useEffect(() => {
    const getKullaniciGPS = () => {
      axios
        .get(`${_serverUrl2}/user/kullanici_gps`)
        .then((response) => {
          const users = response.data.rows;
          setUserList(users);
          userLayer.getSource().clear();
          users.map((user) => {
            return addSingleFeatureTouserLayerByXY(user.lon, user.lat, user.name + "\n" + user.date);
          });
        })
        .catch((error) => {
          console.error("Kullanıcı Konumu Getirme Hatası:", error);
        });
    };

    // Component açıldığında ​​​​verileri hemen al
    getKullaniciGPS();

    // Her 10 saniyede bir veri getir
    const intervalId = setInterval(getKullaniciGPS, 10000);

    MyMap.setTarget("map");
    MyMap.on("singleclick", onClickMap);

    if (MyMap.getLayers().getArray().length === 2 || MyMap.getLayers().getArray().length === 1) {
      addMainLayersToMap(MyMap, getUserInfo.Rol);

      MyMap.addOverlay(mapPopup);
    }
    MyMap.addLayer(userLayer);
    MyMap.addLayer(locationLayer);
    return () => {
      // Component kapatıldığında interval'ü kaldır/temizle
      clearInterval(intervalId);
      MyMap.setTarget(null);
      MyMap.un("singleclick", onClickMap);
      MyMap.removeLayer(locationLayer);
      MyMap.removeLayer(userLayer);
    };
  }, [getUserInfo.Rol, onClickMap]);

  useEffect(() => {
    if (isInfo) {
      MyMap.un("singleclick", onClickMap);
    } else {
      MyMap.on("singleclick", onClickMap);
    }
    return () => {
      if (!isInfo) {
        MyMap.un("singleclick", onClickMap);
      }
    };
  }, [isInfo, onClickMap]);

  return (
    <>
      <div id="map" style={{ height: "100%", width: "130%" }}>
        <div className="map-overlay-container">
          <AdresComponent setMapInterAction={(e) => setIsInfo(e)} />
          <ActiveUsers list={userList} />
          <LayersComponent2 setDisplaySVG={(d) => setDisplaySVG(d)} />
        </div>
      </div>
      <div
        style={{
          position: "absolute",
          bottom: "5px",
          right: "4px",
          zindex: "1",
          background: "rgba(235, 234, 232, .7)",
          display: isSvgOpen?.isOpen ? "" : "none",
        }}
      >
        <img alt="isSvgOpen" src={`data:image/svg+xml;utf8,${encodeURIComponent(isSvgOpen?.svg)}`} />
      </div>
    </>
  );
}
